<script lang="ts">
    import { createEventDispatcher } from 'svelte';

    export let checked: boolean = false;
    export let label: string = '';
    export let offLabel: string = '';
    export let disabled: boolean = false;
    export let colorOff: boolean = false;

    const dispatch = createEventDispatcher();

    function handleChange() {
        dispatch('change', { checked });
    }
</script>

<label style="display:flex; align-items: center; cursor:pointer; column-gap: 6px;" class:disabled class:color-off={colorOff}>
    {#if offLabel}
        <div>{@html offLabel}</div>
    {/if}
    <div class="switch">
        <input type="checkbox" bind:checked on:change={handleChange} {disabled} />
        <span class="slider" />
    </div>
    {#if label}
        <div>{@html label}</div>
    {/if}
</label>

<style>
    .disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 35px;
        min-width: 35px;
        height: 19px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: 0.4s;
        transition: 0.4s;
        border-radius: 34px;
    }

    .slider:before {
        position: absolute;
        content: '';
        height: 13px;
        width: 13px;
        left: 4px;
        bottom: 3px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
        border-radius: 50%;
    }

    input:checked + .slider {
        /*background-color: #84c328;*/
        /*background-color: var(--automapa-blue-dark);*/
        /*background-color: #1c5dc7;*/
        background-color: var(--planning-page-accent-color);
    }

    .color-off .slider {
        background-color: var(--planning-page-accent-color);
    }

    /*input:checked + .slider {*/
    /*    box-shadow: 0 0 1px #84c328;*/
    /*}*/

    input:checked + .slider:before {
        -webkit-transform: translateX(15px);
        -ms-transform: translateX(15px);
        transform: translateX(15px);
    }
</style>
